export const API_URL = import.meta.env.VITE_API_URL || 'http://api2.docgen.dev/api/v1';
export const GOOGLE_CALLBACK_URL =`${API_URL}/auth/google-auth-callback`
export const GITHUB_CALLBACK_URL = `${API_URL}/auth/github-auth-callback`

// Single source of truth for allowed emails
export const ALLOWED_EMAILS = [
  "aniket84792@gmail.com",
  "varshith.gudur17@gmail.com",
  "test-998271@docgen.dev"
  // Add more emails as needed
];